export const APP_STORE_URL =
  'https://apps.apple.com/us/app/surely/id1586633713';
